import { useState } from "react";
import "./App.css";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Hero from "./components/Hero";
import Services from "./components/Services";

function App() {
  // Galeri modal'ını kontrol etmek için state
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div className="App">
      {/* Ana Bölümler */}
      <Hero />
      <About />
      <Services />
      <Gallery onImageClick={setSelectedImage} />
      <Contact />
      <Footer />

      {/* Büyütülmüş Görsel Modal'ı (Popup) */}
      {selectedImage && (
        <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setSelectedImage(null)}
            >
              &times;
            </button>
            <img src={selectedImage} alt="Büyütülmüş Vaka Görseli" />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
